import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
//import { TypeAnimation } from 'react-type-animation';
import Typewriter from 'typewriter-effect';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src="https://media.licdn.com/dms/image/v2/C4E03AQEwZd3qmynnzg/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1516955222190?e=1751500800&v=beta&t=I6K_0k-Y9A3p8Fht_O-t58pRik4odq5JVE9tRPgqqck" alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/salemkarim" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/karim-salem/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1><Typewriter
                  options={{
                    autoStart: true,
                    loop: true,
                    cursor:'|',
                  }}
                  onInit={(typewriter) => {
                    typewriter.typeString('Karim SALEM')
                      .pauseFor(7000)
                      .deleteAll()
                      .typeString('SKSI')
                      .pauseFor(5000)
                      .deleteAll()
                      .start();
                  }}
                /></h1>
          <p><Typewriter
                  options={{
                    autoStart: true,
                    loop: true,
                    delay:50,
                    cursor:'',
                  }}
                  onInit={(typewriter) => {
                    typewriter.typeString('#Security Engineer')
                      .pauseFor(7000)
                      .deleteChars(17)
                      .typeString('Network Administrator')
                      .pauseFor(5000)
                      .deleteChars(21)
                      .typeString('Developper')
                      .pauseFor(3000)
                      .deleteChars(10)
                      .typeString('Photographer')
                      .pauseFor(1000)
                      .deleteChars(12)
                      .start();
                  }}
                /></p>

          <div className="mobile_social_icons">
            <a href="https://github.com/salemkarim" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/karim-salem/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;